exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-records[data-v-765818bf]{margin:150px 0 300px}@media screen and (max-width:768px){.background-image[data-v-765818bf]{margin-top:100px}.no-records[data-v-765818bf]{margin:150px 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-765818bf","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/search.vue
// module id = oD8g
// module chunks = 0